import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"

const Card = styled.div`
    display: flex;
    align-items: center;
    background: var(--gray-lightest);
    padding: var(--space-sm) var(--space-unit);
    color: var(--gray-dark);
    border-radius: 5px;
    margin: var(--space-xs);
    cursor: pointer;
    transition: all 0.5s var(--cubic-bezier);
    &:hover {
        background: var(--white);
        color: var(--black);
        box-shadow: 0 19px 38px rgba(0, 0, 0, 0.15),
            0 15px 12px rgba(0, 0, 0, 0.11);
    }
    .dot {
        width: 24px;
        height: 24px;
        border-radius: 100%;
        margin-right: var(--space-xs);
    }
    .title {
        font-weight: 700;
        color: var(--black);
        margin-bottom: 0;
        margin-left: var(--space-xxxxs);
    }
`

export default () => (
    <section className="category-list bg-green text-white">
        <div className="container">
            <div className="row d-flex justify-content-center">
                <div className="col-md-8">
                    <h1 className="display-4 mb-5 text-center">
                        Explore more great articles by category.
                    </h1>
                    <div className="d-flex justify-content-center flex-wrap">
                        <Link
                            className="text-decoration-none"
                            to="/individual-and-family"
                            data-wa-link="post selection:individual-and-family"
                        >
                            <Card>
                                <div className="dot bg-blue"></div>
                                <h5 className="title">Individual & Family</h5>
                            </Card>
                        </Link>
                        <Link
                            className="text-decoration-none"
                            to="/small-business"
                            data-wa-link="post selection:small-business"
                        >
                            <Card>
                                <div className="dot bg-red"></div>
                                <h5 className="title">Small Business</h5>
                            </Card>
                        </Link>
                        <Link
                            className="text-decoration-none"
                            to="/medicare"
                            data-wa-link="post selection:medicare"
                        >
                            <Card>
                                <div className="dot bg-blue-light"></div>
                                <h5 className="title">Medicare</h5>
                            </Card>
                        </Link>
                        <Link
                            className="text-decoration-none"
                            to="/dental-insurance"
                            data-wa-link="post selection:dental-insurance"
                        >
                            <Card>
                                <div className="dot bg-orange"></div>
                                <h5 className="title">Dental</h5>
                            </Card>
                        </Link>
                        <Link
                            className="text-decoration-none"
                            to="/vision-insurance"
                            data-wa-link="post selection:vision-insurance"
                        >
                            <Card>
                                <div className="dot bg-blue-text"></div>
                                <h5 className="title">Vision</h5>
                            </Card>
                        </Link>
                        <Link
                            className="text-decoration-none"
                            to="/short-term"
                            data-wa-link="post selection:short-term"
                        >
                            <Card>
                                <div className="dot bg-gray-lighter"></div>
                                <h5 className="title">Short-term</h5>
                            </Card>
                        </Link>
                        <Link
                            className="text-decoration-none"
                            to="/affordable-care-act"
                            data-wa-link="post selection:affordable-care-act"
                        >
                            <Card>
                                <div className="dot bg-green-light"></div>
                                <h5 className="title">Affordable Care Act</h5>
                            </Card>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </section>
)
